<form [formGroup]="form" id="form" (ngSubmit)="submitChanges()" *ngIf="form">
  <div *ngIf="type === EditOrderInstructionsFlowTypes.Neighbour">
    <div class="label-input-container">
      <label>Neighbour’s address + instructions</label>
      <textarea
        rows="4"
        class="e-input"
        [class.invalid]="displayErrors"
        formControlName="content1"
        placeholder="Enter neighbour’s address here"
        trackable="Edit delivery/Instructions/{{ type }}/content"></textarea>
    </div>
    <div class="label-input-container">
      <label>Neighbour’s phone number <span class="optional">(optional)</span></label>
      <common-intl-phone-number
        controlName="content2"
        [class.invalid]="phoneError"
        trackable="Edit delivery/Instructions/{{ type }}/phone number"></common-intl-phone-number>
    </div>
  </div>

  <div *ngIf="type === EditOrderInstructionsFlowTypes.SafePlace">
    <button
      *ngFor="let option of safePlaceOptions"
      class="radio-option safe-place"
      type="button"
      (click)="onSelectSafePlace(option)"
      [class.active]="form.get('content1')?.value === option.type"
      trackable="Edit delivery/Instructions/{{ type }}/{{ option.title }}">
      <div class="safe-place-content1-container">
        <ng-container *ngComponentOutlet="option.icon; inputs: { color: brandColor }"></ng-container>
        <span>{{ option.title }}</span>
      </div>
      <div class="safe-place-content2-container" *ngIf="form?.get('content1')?.value === option.type">
        <div class="label-input-container">
          <label
            >{{ option.label2 }}
            <span class="optional" *ngIf="option.type !== SafePlaceTypes.Other">(optional)</span></label
          >
          <textarea
            class="e-input"
            trackable="Edit delivery/Instructions/{{ type }}/{{ option.title }}/content"
            formControlName="content2"
            [placeholder]="option.content2Placeholder"></textarea>
        </div>
      </div>
    </button>
  </div>

  <div *ngIf="type === EditOrderInstructionsFlowTypes.CourierNote">
    <div class="label-input-container">
      <label>Write your note here</label>
      <textarea
        rows="5"
        class="e-input"
        [class.invalid]="displayErrors"
        trackable="Edit delivery/Instructions/{{ type }}/content"
        formControlName="content1"
        placeholder="e.g. Please don’t ring the bell - call me when you’re here"></textarea>
    </div>
  </div>
</form>

<div class="button-container" *ngIf="form">
  <button
    type="submit"
    id="submit-button"
    form="form"
    [disabled]="form.pristine || loading || form.invalid"
    [style.color]="textColor"
    [style.background-color]="brandColor">
    Save instructions
    <img *ngIf="loading" src="../assets/loading-circle-white-animated.svg" />
  </button>
</div>
